import { useMemo } from "react";
import { encodeQr } from "@iltocat/shared";

const QUIET = 4;

/**
 * A QR code as one SVG path, so it prints sharply at any size and needs no
 * image request. The colours come from the label tokens, which are black on
 * white in both themes: a code that inverts with the dark theme does not scan.
 */
export function QrCode({ text, label }: { text: string; label: string }) {
  const drawn = useMemo(() => {
    const result = encodeQr(text);
    if (!result.ok) return null;
    let path = "";
    result.matrix.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) path += `M${x + QUIET} ${y + QUIET}h1v1h-1z`;
      }),
    );
    return { path, size: result.matrix.length + QUIET * 2 };
  }, [text]);

  if (!drawn) return <span className="muted small">This is too long for a label code.</span>;

  return (
    <svg
      className="qr"
      viewBox={`0 0 ${drawn.size} ${drawn.size}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect className="qr-paper" width={drawn.size} height={drawn.size} />
      <path className="qr-ink" d={drawn.path} />
    </svg>
  );
}
